import RegItemImage from './reg-item-image'

export default RegItemImage
